import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'join',
})
export class JoinPipe implements PipeTransform {
  transform<T>(array: T[], separator: string = ', '): string {
    return array.filter(Boolean).join(separator);
  }
}
